interface TagsSectionProps {
	currentRole?: string;
}

export function TagsSection({ currentRole }: TagsSectionProps) {
	const getTagText = () => {
		if (
			currentRole &&
			(currentRole.includes("Founder") || currentRole.includes("CEO"))
		) {
			return "Startup Founder";
		}
		return currentRole || "";
	};

	const tagText = getTagText();

	return (
		<div className="flex flex-wrap gap-2">
			{tagText && (
				<span
					className="px-3 py-1.5 rounded-full text-sm"
					style={{
						backgroundColor: "#F3F4F6",
						color: "#1D1D1D",
						fontFamily: "Inter, sans-serif",
					}}
				>
					{tagText}
				</span>
			)}
		</div>
	);
}
